type SyncedEmail = { type: string; subject: string | null; date: string; webLink: string | null };

// A hand-logged email is an activity row AND comes back from the emails
// endpoint as type "logged"; the activity wins. The same message synced into
// two teammates' mailboxes is two rows with one subject and send time. The
// server links only the viewer's own copy (an Outlook ItemID is per mailbox),
// so keep the copy with a link, or the Outlook button vanishes.
export function collapseSyncedEmails<E extends SyncedEmail>(emails: E[]): E[] {
  const out: E[] = [];
  const at = new Map<string, number>();
  for (const e of emails) {
    if (e.type === "logged") continue;
    const k = `${e.subject ?? ""}|${e.date}`;
    const i = at.get(k);
    if (i === undefined) {
      at.set(k, out.length);
      out.push(e);
    } else if (!out[i].webLink && e.webLink) {
      out[i] = e;
    }
  }
  return out;
}
